<template>
  <div>
    <top-bar heading="Units" :buttons="buttons"></top-bar>
    <loading-spinner :loading="!units.length"></loading-spinner>
    <div class="container-fluid mt-3" v-if="units.length">
      <b-card header="Units">
        <vue-good-table
                :columns="columns"
                :rows="units"
                :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 10,
                  position: 'bottom',
                  perPageDropdown: [10, 25, 50, 100],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }"
        >
          <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'published'">
                <span class="badge badge-success p-2" v-if="props.row.published">Published</span>
                <span class="badge badge-danger p-2" v-if="!props.row.published">Draft</span>
              </span>
            <span v-else-if="props.column.field === 'actions'" class="btn-group">
                  <b-button variant="success" :to="'/units/' + props.row.id"><font-awesome-icon icon="edit"></font-awesome-icon></b-button>
                  <b-button variant="danger" @click="deleteUnit(props.row.id)"><font-awesome-icon icon="trash"></font-awesome-icon></b-button>
              </span>
            <span v-else-if="props.column.field === 'codes'">
                {{ props.row.codes.map(code => code.name).join(', ') }}
              </span>
            <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
          </template>
        </vue-good-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import findIndex from 'lodash-es/findIndex';

export default {
  name: 'Units',
  data () {
    return {
      columns: [
        {
          field: 'id',
          label: 'ID',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Codes',
          field: 'codes',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Published',
          field: 'published',
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              {value: 0, text: 'Draft'},
              {value: 1, text: 'Published'}
            ]
          }
        },
        {
          label: 'Created',
          field: 'created_at',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Updated',
          field: 'updated_at',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
      buttons: [
        {
          label: 'Add New Unit',
          click: () => {
            this.axios.post('/courses', {name: 'New Unit'}).then(rsp => {
              this.$snotify.success('Unit Created');
              this.$store.commit('setUnits', [...this.units].unshift(rsp.data));
            }).catch(err => this.$errorOut(err));
          }
        }
      ]
    };
  },
  methods: {
    deleteUnit (id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This will delete the selected unit for all students!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/courses/' + id).then(() => {
            this.$snotify.success('Unit Deleted');
            let index = findIndex(this.courses, {id});
            this.courses.splice(index, 1);
          }).catch(err => this.$errorOut(err));
        }
      });
    }
  },
  computed: {
    units () {
      return this.$store.state.units;
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_UNITS', this);
  },
  metaInfo: {
    title: 'Units'
  }
};
</script>
